import { createFileRoute } from '@tanstack/react-router';
import {
  extractTranslations,
  getPresentationText,
  useFeatureConfiguration,
} from '@portal/platform/configuration';
import { requireFeature } from '@portal/platform/guards';
import { useSession } from '@portal/platform/session';
import { AppLink, useShellTexts } from '@portal/ui';
import { APP_CONFIG } from '@/config';

/**
 * The user's profile. Angular's edit form loaded and saved nothing (it announced success
 * regardless), so it is not ported; the test-customers editor for GLOBAL admins moves in its own
 * run and is linked in the Angular portal until then.
 */
export const Route = createFileRoute('/_app/profile')({
  staticData: { featureKey: 'profile' },
  beforeLoad: ({ context, location }) => requireFeature(context, location, { feature: 'profile' }),
  component: Profile,
});

function Profile() {
  const t = useShellTexts().profile;
  const { identity, isGlobalAdmin } = useSession();
  const configuration = useFeatureConfiguration().data;
  const title = getPresentationText(extractTranslations(configuration), 'title');
  const legacy = APP_CONFIG.LEGACY_PORTAL_URL;

  return (
    <section className="mx-auto max-w-xl rounded-lg bg-white p-8 shadow-sm">
      {title ? <h1 className="mb-4 text-2xl font-semibold text-gray-900">{title}</h1> : null}
      {identity?.name ? <p className="mb-6 text-lg text-gray-800">{identity.name}</p> : null}
      <AppLink href="/reset-password" className="text-gray-900 underline">
        {t.changePassword}
      </AppLink>
      {isGlobalAdmin ? (
        <div className="mt-8 border-t border-gray-200 pt-6">
          <h2 className="mb-2 text-lg font-semibold text-gray-900">{t.testCustomers}</h2>
          {legacy ? (
            <a href={`${legacy}/profile`} className="text-gray-900 underline">
              {t.testCustomersMoved}
            </a>
          ) : (
            <p className="text-gray-600">{t.testCustomersMoved}</p>
          )}
        </div>
      ) : null}
    </section>
  );
}
